import { render, staticRenderFns } from "./turnon-auto-bcn.vue?vue&type=template&id=71a82cb2&"
import script from "./js/turnon-auto-bcn.js?vue&type=script&lang=js&"
export * from "./js/turnon-auto-bcn.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports